import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, Platform, ActivityIndicator, TouchableOpacity } from 'react-native';
import { Screen, Text, Button, Input, Colors } from '../components';
import { StringUtils } from '../utils';
import { HomePetsList } from '../containers';
import PetController   from '../controllers/petController';
import AuthController  from '../controllers/authController';
import UserController  from '../controllers/userController';
import { useNavigate } from 'react-router-dom';
import { WebView }     from 'react-native-webview';

class SettingsManageSubscriptionScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      manage_page_url: '',
      no_subscription: false,
      loading_url: false
    }
  }

  async componentDidMount() {
    this.pull_subscription_details();
  }

  pull_subscription_details = async () => {
    this.setState({ loading_url: true }, async () => {
      let user     = await AuthController.getUser();
      let sub_url  = await UserController.getSubscriptionManageUrl({});
      let page_url = '';
      let no_sub   = false;

      if (sub_url && sub_url.success) {
        page_url = sub_url.url;
        no_sub   = sub_url.no_subscription && sub_url.no_subscription === true ? true : false;
      }

      this.setState({ user: user, manage_page_url: page_url, loading_url: false, no_subscription: no_sub });
    });
  }

  render_loading_interface = () => {
    return <View style={{ flex: 1, paddingTop: 25, alignItems: 'center' }}>
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <View style={{ height: 25, width: 25, marginRight: 10 }}>
          <Progress.CircleSnail size={25} fill='#00000000' indeterminate={true} color={ Colors.PRIMARY  } />
        </View>
        <Text style={{ fontSize: 16, color: 'grey' }}>Loading Subscription Data...</Text>
      </View>
    </View>
  }

  render_no_sub_interface = () => {
    return <View style={{ flex: 1, paddingTop: 25, alignItems: 'center' }}>
      <Text style={{ fontSize: 16, color: 'grey' }}>You do not have an active DodoVet Subscription.</Text>
    </View>
  }

  render() {
    let display_web_view = !this.state.loading_url && this.state.manage_page_url;
    let display_no_sub   = !this.state.loading_url && !this.state.manage_page_url && this.state.no_subscription === true;
    let display_loading  =  this.state.loading_url;

    return (
      <Screen navigation={this.props.navigation} title={'Manage Subscription'} auth={true} auth_success={ () => { this.pull_subscription_details() }}>
        { display_web_view ? <WebView style={styles.stripe_view_container} source={{ uri: this.state.manage_page_url }} /> : null }
        { display_loading  ? this.render_loading_interface() : null }
        { display_no_sub   ? this.render_no_sub_interface()  : null }
      </Screen>
    );
  }
}

function SettingsManageSubscriptionScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <SettingsManageSubscriptionScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SettingsManageSubscriptionScreen_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({
  stripe_view_container: {
    flex: 1
  }
});

export default SettingsManageSubscriptionScreen
